import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_PUBLIC_KEY: string = '[ecommerce public key] Load Ecommerce Payment Methods';
export const LOAD_ECOMMERCE_PUBLIC_KEY_SUCCESS: string = '[ecommerce public key] Load Ecommerce Payment Methods Success';
export const LOAD_ECOMMERCE_PUBLIC_KEY_FAIL: string = '[ecommerce public key] Load Ecommerce Payment Methods Fail';

export class LoadEcommercePublicKey implements Action {
  readonly type: string = LOAD_ECOMMERCE_PUBLIC_KEY;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommercePublicKeySuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PUBLIC_KEY_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommercePublicKeyFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_PUBLIC_KEY_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommercePublicKeyAction = LoadEcommercePublicKey | LoadEcommercePublicKeySuccess | LoadEcommercePublicKeyFail;
